import React, { createRef, useState, useEffect, useContext } from "react";
import Dropzone from "react-dropzone";

import SharedThumbIcon from "../../images/upload-thumb-image.svg";
import InfoIcon from "../../images/InfoIconGray.svg";
import "./SharedResource.scss";
import DeleteIcon from "../../images/remove-icon.svg";
import { uploadSharedFiles, deleteSharedFiles } from "../../services/apis";
import CustomTooltip from "../../components/Tooltip/Tooltip";
import Addmore from "../../images/AddPlus-Icon-White.svg";
import { showErrorToast, showSuccessToast, showWarningToast } from "../toastComponent/ToastComponent";

const SharedThumbImage = (props) => {
  const { deckId, setAllThumb, deckData } = props;
  const dropzoneRef = createRef();
  const [thumbImage, setThumbImage] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [deletedValue, setDeletedValue] = useState({});
  const fontExt = ["image/png"];

  useEffect(() => {
    setThumbImage(deckData?.deck_shared_assets?.thumb || []);
    setAllThumb(deckData?.deck_shared_assets?.thumb || []);
  }, []);

  const onFileSelection = (accepted, rejected) => {
    const notAllowedFiles = accepted.filter(
      (file) => !fontExt.includes(file.type)
    );
    const filterExt = accepted.filter((file) => fontExt.includes(file.type));
    notAllowedWarn(notAllowedFiles);
    const formData = new FormData();
    if (filterExt.length > 0) {
      let formDatalength = false;
      filterExt.forEach((uploadFile) => {
        if (uploadFile.size < 5242880) {
          formDatalength = true;
          formData.append("thumb", uploadFile);
        } else {
          toastErrorForBigImage("File Upload unsuccessful");
        }
      });
      if (formDatalength) {
      }
      uploadSharedFiles(deckId, formData, (response, err, ErrorCode) => {
        if (err) {
          // toastErrorThrow([], "Upload");
          toastErrorThrow(err.response.data.err[0].msg, "Upload");
        } else {
          const data = response?.data?.response?.allThumb;
          const failedFiles = response.data.err;
          setThumbImage(data);
          setAllThumb(data);
          toastSuccesThrow("Uploaded Successfully");
          if (failedFiles.length > 0) toastErrorThrow(failedFiles, "Upload");
        }
      });
    }
  };

  const deleteHandler = (list) => {
    setDeletedValue(list);
  };

  const deleteHandlerConfirmation = (type) => {
    if (type === "No") {
      setDeletedValue({});
    } else {
      const payloadObj = { list: deletedValue, deckId: deckId };
      deleteSharedFiles(payloadObj, (response, err, ErrorCode) => {
        if (err) {
          toastErrorThrow([], "Delete");
        } else {
          setThumbImage([]);
          setAllThumb([]);
          setDeletedValue({});
          // const data = response?.data?.response?.allImages;
          // console.log(response?.data, 'data---77')
          toastSuccesThrow("Deleted Successfully");
        }
      });
    }
  };

  const notAllowedWarn = (files) => {
    if (files.length > 0) toastWarnThrow(files);
  };

  const toastErrorForBigImage = (action) => {
    showErrorToast(action, 'Cannot upload size of image more than 500Kb');
    // toast.error(
    //   <div className="toast-text-message">
    //     <div className="toast-title error-msg">{action}</div>
    //     <div className="toast-title-msg">
    //       Cannot upload size of image more than 500Kb
    //     </div>
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: <img className="toast-error-icon align-img" src={ErrorIcon} />,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className:
    //       "toast-popup toast-error-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };
  const toastErrorThrow = (failedFiles, action) => {
    if(Array.isArray(failedFiles)) {
      showErrorToast(action, `${failedFiles.length > 0 && `${failedFiles.length}files failed to upload. Pl try again`}`);
    } else {
        showErrorToast(action, `${failedFiles} files failed to upload. Pl try again`);
    }
    // showErrorToast(action, `${failedFiles.length > 0 && `${failedFiles.length}files failed to upload. Pl try again`}`);
    
    // toast.error(
    //   <div className="toast-text-message">
    //     <div className="toast-title error-msg">{action} Unsuccessful</div>
    //     {failedFiles.length > 0 && (
    //       <div className="toast-title-msg">
    //         {failedFiles.length} files failed to upload. Pl try again
    //       </div>
    //     )}
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: (
    //       <img
    //         className={`toast-error-icon ${
    //           failedFiles.length > 0 ? "align-img" : ""
    //         }`}
    //         src={ErrorIcon}
    //       />
    //     ),
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className:
    //       "toast-popup toast-error-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  const toastSuccesThrow = (msg) => {
    showSuccessToast(msg);
  };

  const toastWarnThrow = (files) => {
    showWarningToast(`${files.length} files are discarded due to wrong Extension. Pl try
          again`, 'Wrong file uploaded');
  };

  return (
    <div className="shared-thumb-image">
      <div
        className={`shared-thumb-image-main ${
          thumbImage?.length > 0 ? "" : "shared-image-main-added-border"
        }`}
      >
        <div className="upload-thumb-image-main" style={{ paddingBottom: 0 }}>
          <div className="upload-thumb-image-content">
            <div className="d-flex divAlignment">
              <a className="chooseFile" href="javascript:void(0)">
                Thumb Image
              </a>
              <CustomTooltip
                classes="info-tooltip"
                title="Only one thumb image can be added."
                arrow
              >
                <img src={InfoIcon} alt="" className="upload-thumb-info-icon" />
              </CustomTooltip>
            </div>
            {false && <Dropzone
              ref={dropzoneRef}
              multiple={false}
              maxFiles={1}
              accept="image/png"
              onDrop={(accepted, rejected) =>
                onFileSelection(accepted, rejected)
              }
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="add-thumb-Image">
                  <img src={Addmore} style={{ marginRight: "13px" }} />{" "}
                  <span>ADD</span>{" "}
                </div>
              )}
            </Dropzone>}
          </div>
        </div>
        {thumbImage?.length <= 0 ? (
          <div className="upload-thumb-image-main" style={{ paddingTop: 0 }}>
            <Dropzone
              ref={dropzoneRef}
              multiple={false}
              maxFiles={1}
              accept="image/png"
              onDrop={(accepted, rejected) =>
                onFileSelection(accepted, rejected)
              }
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="upload-file-section">
                  <input {...getInputProps()} />
                  <img
                    src={SharedThumbIcon}
                    width="12px"
                    height="12px"
                    className="upload-thumb-icon"
                  />
                  <span>ADD THUMB IMAGE</span>
                </div>
              )}
            </Dropzone>
          </div>
        ) : (
          <div className="uploaded-shared-main">
            <div className="customScrollBar uploaded-shared-list">
              {thumbImage?.map((list) => (
                <div className="uploaded-shared">
                  <div
                    className={`uploaded-shared-content d-flex justify-content-between align-items-center ${
                      deletedValue?.name === list?.name
                        ? "added-border-bottom"
                        : ""
                    }`}
                  >
                    <div className="d-flex" style={{alignItems:'center'}}>
                      <img
                        className="uploaded-shared-content-image"
                        src={list?.link}
                        alt=""
                        width={24}
                        height={24}
                      />
                      <p
                        className={`uploaded-shared-name ${
                          Object.keys(list?.name).length > 16
                            ? "image-details-tooltip"
                            : ""
                        }`}
                        data-title={
                          Object.keys(list?.name).length > 16 ? list?.name : ""
                        }
                        title={list?.name}
                      >
                        {list?.name?.replace(/\.[^/.]+$/, "")}
                      </p>
                    </div>
                    <img
                      src={deletedValue?.name !== list?.name ? DeleteIcon : ""}
                      className="delete-uploaded-shared"
                      onClick={() => deleteHandler(list)}
                    />
                  </div>
                  {deletedValue?.name === list?.name ? (
                    <div className="delete-conformation-thumb-image">
                      <h2 className="delete-conformation-thumb-image-message">
                        The image to be deleted might have been used in slides.
                        <span>Are you sure?</span>
                      </h2>
                      <div className="d-flex justify-content-between">
                        <button
                          className="delete-conform-thumb-image-no btn btn-default"
                          onClick={() => deleteHandlerConfirmation("No")}
                        >
                          NO
                        </button>
                        <button
                          className="delete-conform-thumb-image-yes btn btn-default"
                          onClick={() => deleteHandlerConfirmation("Yes")}
                        >
                          YES, DELETE
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SharedThumbImage;
